import React, { Component } from 'react'
import VimeoPlayer from '@vimeo/player'
import PlayButton from '../PlayButton'
import Rx from 'rxjs'
import styles from './Vimeo.css'

export default class Vimeo extends Component {
  state = {
    showVideo: false,
  }

  handleImageMouseDown = (e) => {
    this.setState({dragStart: e.clientX})
  }

  handleImageMouseUp = (e) => {
    this.setState({dragEnd: e.clientX})
  }

  handleImageClick = () => {
    if (Math.abs(this.state.dragEnd - this.state.dragStart) < 10) {
      this.setState({showVideo: true})
    }
  }

  handleStop = () => {
    this.setState({showVideo: false})
  }

  render () {
    return (
      this.props.noImage || this.state.showVideo ? (
        <Video video={this.props.video} id={this.props.id} onStop={this.handleStop}/>
      ) : (
        <div
          className={styles.img}
          style={{
            backgroundImage: 'url('+this.props.image+')' || '',
          }}
          onMouseDown={this.handleImageMouseDown}
          onMouseUp={this.handleImageMouseUp}
          onClick={this.handleImageClick}
        >
          <PlayButton/>
        </div>
      )
    )
  }

}

class Video extends Component {
  componentDidMount () {
    var player = new VimeoPlayer(this.videoCont, {
      id: this.props.video,
      width: 1280,
      autoplay: true,
    })

    player.on('pause', this.props.onStop)
    player.on('ended', this.props.onStop)
    player.on('error', this.props.onStop)

    const escapeKey$ = Rx.Observable.fromEvent(document, 'keydown').filter(e => e.key === 'Escape')
    this.escapeSubscription = escapeKey$.subscribe(() => {player.pause()})
  }

  componentWillUnmount () {
    this.escapeSubscription.unsubscribe()
  }

  render () {
    return (
      <div className={styles.videoCont} onClick={this.handleVideoClick}>
        <div className={styles.video} ref={videoCont => {this.videoCont = videoCont}}/>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/Rist/modules/Vimeo/index.js